import React, { Component, createRef } from "react";
import spine from "../spine/runtime/spine-widget";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import GIF from "gif.js";
export class Spine extends Component {
  rootRef;
  delta = { x: 0, y: 0 };
  constructor(props) {
    super(props);
    this.rootRef = createRef();
  }
  ensureEncoder(ws, name, progress, success) {
    this.encoder = new GIF({
      background: "#00",
      quality: 1,
      height: 1000,
      width: 1000,
      workers: 4,
      workerScript: ws,
      debug: true,
      repeat: -1,
    });
    this.encoder.gifFilename = name;
    this.encoder.on("finished", (blob) => {
      const dom = document.createElement("a");
      dom.href = URL.createObjectURL(blob);
      dom.download = this.encoder.gifFilename;
      dom.click();
      success();
    });
    this.encoder.on("progress", (num) => {
      console.log(num);
      progress(num);
    });
  }
  reset() {
    this.skeleton.x = 500;
    this.skeleton.y = 200;
  }
  render() {
    return (
      <div
        style={{
          width: 200,
          height: 200,
          overflow: "hidden",
        }}
      >
        <Backdrop
          open={this.props.loading}
          style={{
            position: "absolute",
            width: 200,
            height: 200,
            zIndex: 1,
            top: "inherit",
            left: "inherit",
            right: "inherit",
            bottom: "inherit",
          }}
        >
          <CircularProgress />
        </Backdrop>
        <div
          style={{
            width: 1000,
            height: 1000,
            transform: `scale(${this.props.scale},${this.props.scale})`,
            transformOrigin: "top left",
          }}
          ref={this.rootRef}
        >
        </div>
      </div>
    );
  }
  componentWillUnmount() {
    this.mc.destroy();
  }
  loadWidget(json, path, ani, hex, loop, skin, speed, cb) {
    this.widget = new spine.SpineWidget(this.rootRef.current, {
      jsonContent: json,
      atlas: path,
      animation: ani,
      backgroundColor: "#" + hex,
      debug: false,
      loop: loop,
      skin: skin,
      x: 325,
      y: 400,
      fitToCanvas: false,
      premultipliedAlpha: true,
      success: (widget) => {
        console.log(widget);
        widget.state.timeScale = speed;
        this.skeleton = widget.skeleton;
        widget.state.addListener({
          start: () => {
            if (this.gif) {
              this.startGif();
            }
          },
          complete: () => {
            if (this.gif) {
              this.gif = false;
              this.encoder.render();
            }
          },
        });
        cb(
          widget.skeleton.data.animations.map((v) => {
            return { duration: v.duration, name: v.name };
          })
        );
      },
    });
  }
  updateAnimation(ani, loop) {
    this.widget.state.setAnimation(0, ani, loop);
  }
  updateColor(r, g, b, a) {
    this.widget.backgroundColor.r = r / 255;
    this.widget.backgroundColor.g = g / 255;
    this.widget.backgroundColor.b = b / 255;
    this.widget.backgroundColor.a = a;
  }
  updateSpeed(speed) {
    this.widget.state.timeScale = speed;
  }
  buildGif(ani) {
    this.gif = true;
    this.updateAnimation(ani, false);
  }
  startGif() {
    if (!this.gif) {
      return;
    }
    this.encoder.addFrame(this.widget.canvas, { copy: true, delay: 1000 / 60 });
    requestAnimationFrame(() => {
      this.startGif();
    });
  }
}
